<template>
  <div
    class="d-flex justify-content-between flex-row align-center top-panel mx-2"
  >
    <div class="d-flex align-center">
      <h2>{{ schema?.title }}</h2>
    </div>
    <div class="d-flex align-center" v-if="isModal">
      <base-button
        @click="closeModal"
        className="v-btn v-theme--BLUE_THEME bg-error v-btn--density-default v-btn--size-default v-btn--variant-flat mr-2"
        v-tooltip:bottom="$t('buttons.cansel')"
        >{{ $t("buttons.cansel") }}
      </base-button>
      <base-button
        :variant="'pure'"
        className="v-btn v-btn--flat v-theme--BLUE_THEME bg-primary-darken-1 v-btn--density-default v-btn--size-default v-btn--variant-elevated ml-auto"
        @click="ExportEntity"
        v-if="activeTab === 'Detail' && cardType === 'show' && schema?.export"
      >
        {{ "Export to conveniq" }}
      </base-button>
      <base-button
        :variant="'pure'"
        className="v-btn v-btn--flat v-theme--BLUE_THEME bg-primary v-btn--density-default v-btn--size-default v-btn--variant-elevated ml-auto"
        aria-haspopup="menu"
        aria-expanded="false"
        aria-owns="v-menu-669"
        @click="saveInstance"
        v-tooltip:bottom="$t('buttons.saveChanges')"
        v-if="activeTab === 'Detail' && cardType !== 'show'"
      >
        {{ $t("buttons.save") }}
      </base-button>
    </div>
  </div>
  <base-tabs
    v-if="tabsList.length > 1"
    v-model="activeTab"
    :tabsList="tabsList"
    :instanceId="item.id"
    @change="onTabChange"
  >
  </base-tabs>
  <div
    class="tabs-content d-flex flex-column"
    style="flex: 1 0 auto"
    ref="tabsContent"
    :style="setStyleModal"
  >
    <div ref="dinamicFormContainer">
      <dinamic-form
        v-if="formShema && activeTab === 'Detail'"
        :schema="formShema"
        :data="formData"
        @model-updated="updateInstanceData"
        @validation-error="onValidationError"
        @get-form-height="onSetFormHeight"
        ref="dinamicForm"
      >
      </dinamic-form>
    </div>
    <instance-card-table
      v-if="activeTabEntity"
      :tableEntity="activeTabEntity"
      :subtableSchema="subtableSchema"
      :parrentEntityId="formData.id"
      :parentData="formData"
      :parentEntity="entity"
      :cardType="cardType"
    ></instance-card-table>
    <component
      v-if="activeEntityModul"
      :is="activeEntityModul"
      :id="item.id"
      :entity="entity"
      :data="item"
      @get-form-height="onSetFormHeight"
      @close-modalf="closeModal"
      @updatedData="getUpdated"
    ></component>
    <spinner v-if="spinnerShow"></spinner>
    <BaseDialog :modelValue="showDialogue">
      <h2 class="d-flex">
        {{ dialogueMessage }}
      </h2>
      <div
        class="d-flex flex-row justify-content-center"
        style="flex-wrap: wrap; gap: 20px"
      >
        <base-button
          :variant="'pure'"
          className="v-btn v-theme--ORANGE_THEME bg-success v-btn--density-default v-btn--size-default v-btn--variant-flat"
          @click="_confirm"
        >
          <h2>{{ okButton }}</h2>
        </base-button>

        <base-button
          :variant="'pure'"
          className="v-btn v-theme--ORANGE_THEME bg-error v-btn--density-default v-btn--size-default v-btn--variant-flat"
          @click="_cancel"
        >
          <h2>{{ cancelButton }}</h2>
        </base-button>
      </div>
    </BaseDialog>
  </div>
</template>
<script>
import { isObject, hasProperty } from "@/helpers";
import { mapState } from "pinia";
import { useUserStore } from "@/stores/userStore";

import DinamicForm from "@/components/formGenerator/DinamicForm.vue";
import BaseTabs from "@/components/BaseTabs.vue";
import InstanceCardTable from "@/pages/entityPages/InstanceCardTable.vue";
import BaseButton from "@/components/BaseButton.vue";
import Analizator from "@/components/instanceModules/Analizator.vue";
import DrawZones from "@/components/instanceModules/DrawZones.vue";
import Advertising from "@/components/instanceModules/Advertizing.vue";
import MlServerCredentials from "@/components/instanceModules/MlServerCredentials.vue";
import GetRecognizedPhoto from "@/components/instanceModules/MlServer_recPhoto.vue";
import AutoAnnotation from "@/components/instanceModules/MlServer_autoanno.vue";
import OneTimePassword from "@/components/instanceModules/oneTimePassword.vue";
import ReceiptCommands from "@/components/instanceModules/ReceiptCommands.vue";
import BaseDialog from "@/components/BaseDialog.vue";

import EntityApi from "@/api/entityApi";
import Spinner from "../../components/Spinner.vue";
export default {
  name: "InstanceCard",
  props: {
    entity: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
    },
    schema: {
      type: Object,
    },
    cardType: {
      type: String,
      default: "edit",
    },
    defaultValues: {
      type: Object,
    },
    isModal: {
      type: Boolean,
      default: true,
    },
    formdinamic: {
      type: Boolean,
      default: true,
    },
    parentData: {
      type: Object,
      default: null,
    },
    parentEntity: {
      type: String,
      default: "",
    },
  },
  inject: [],
  emits: ["inctanseDataUpdate", "inctanseCreate", "closeModal", "dataUpdate"],
  components: {
    Spinner,
    DinamicForm,
    BaseButton,
    BaseTabs,
    InstanceCardTable,
    Analizator,
    DrawZones,
    MlServerCredentials,
    GetRecognizedPhoto,
    AutoAnnotation,
    Advertising,
    OneTimePassword,
    ReceiptCommands,
    BaseDialog,
  },
  data() {
    return {
      spinnerShow: false,
      activeTab: "Detail",
      noDetailEntit: ["monitoring"],
      formShema: [],
      formData: null,
      formError: null,
      buildInModules: [],
      dinamicFormHeight: 0,
      heightMult: 0.9,

      filesNotSaved: [],

      showDialogue: false,
      dialogueMessage: "",
      okButton: "",
      cancelButton: "",
      resolvePromise: undefined,
      rejectPromise: undefined,
    };
  },
  watch: {
    activeTab: {
      handler() {
        this.removeNotSaved();
      },
      deep: true,
    },
  },
  computed: {
    ...mapState(useUserStore, ["user"]),
    tabsList() {
      let tablist = [];

      if (this.schema?.table_fields && this.schema.table_fields.length > 0) {
        this.schema?.table_fields.forEach((element) => {
          tablist.push(this.schema?.properties[element]?.title);
        });
      }

      if (
        hasProperty(this.schema, "built_in_modules") &&
        this.schema.built_in_modules?.length > 0
      ) {
        this.schema.built_in_modules.forEach((el) => {
          if (el.position === "tabs") {
            tablist.push(el.label);
            this.buildInModules.push(el);
          }
        });
      }

      if (tablist.length > 0 && !this.noDetailEntit.includes(this.entity)) {
        tablist.unshift("Detail");
      }

      return tablist;
    },
    activeEntityModul() {
      if (this.buildInModules.length > 0) {
        let modul = this.buildInModules.find(
          (el) => el.label === this.activeTab
        );
        if (modul) {
          return modul.component;
        } else return null;
      } else return null;
    },
    activeTabEntity() {
      if (this.activeTab.length > 0) {
        const activeTabObject = Object.entries(this.schema.properties).find(
          (el) => el[1].title === this.activeTab
        );
        if (activeTabObject) {
          return activeTabObject[1];
        } else return null;
      } else return null;
    },
    subtableSchema() {
      if (this.activeTabEntity) {
        let entityName = this.activeTabEntity?.items?.$ref.slice(14);
        return this.schema?.definitions[entityName];
      } else return null;
    },
    setStyleModal() {
      if (this.isModal) {
        const windowHeight = window.innerHeight;
        const contentModalHeight = windowHeight * this.heightMult;
        return {
          height: `${contentModalHeight - 20}px`,
          overflow: "auto",
        };
      }

      return {
        overflow: "hidden",
      };
    },
    weekdays() {
      return [
        { id: 1, name: this.$t("weekdays.monday") },
        { id: 2, name: this.$t("weekdays.tuesday") },
        { id: 3, name: this.$t("weekdays.wednesday") },
        { id: 4, name: this.$t("weekdays.thursday") },
        { id: 5, name: this.$t("weekdays.friday") },
        { id: 6, name: this.$t("weekdays.saturday") },
        { id: 7, name: this.$t("weekdays.sunday") },
      ];
    },
  },
  methods: {
    generateNewSchemaElement(item, property) {
      let newElement = {
        columns: {
          container: 6,
        },
      };
      newElement.id = item;
      newElement.name = item;
      newElement.label = property.title;

      switch (property.type) {
        case "string":
          newElement.type = "text";
          break;
        case "integer":
          newElement.type = "text";
          newElement.inputType = "number";
          break;
        case "number":
          newElement.type = "text";
          newElement.inputType = "number";
          break;
        case "boolean":
          newElement.type = "toggle";
          break;
        case "object":
          newElement.type = "json";
          break;
        case "weekdays":
          newElement.type = "multiselect";
          newElement.multiple = true;
          newElement.items = this.weekdays;
          newElement.object = true;
          break;
        case "multiselect":
          newElement.type = "multiselect";
          newElement.multiple = property?.multiple ?? false;
          newElement.search = property?.search ?? false;
          if (property?.items) {
            if (Array.isArray(property.items)) {
              newElement.items = property.items;
            } else {
              let entityName = property.items?.$ref?.slice(14);
              let entity = this.schema?.definitions[entityName];
              if (hasProperty(entity, "model")) {
                newElement.items = {
                  entity: entity?.model,
                  valueName: "id",
                  titleName: property.title_field_name
                    ? property.title_field_name
                    : "name",
                };

                newElement.object = true;
              }
              if (hasProperty(entity, "enum")) {
                newElement.items = entity.enum;
              }
            }
          }
          break;
        default:
          break;
      }
      if (
        newElement.items &&
        Array.isArray(newElement.items) &&
        newElement.items.length &&
        typeof newElement.items[0] === "object"
      ) {
        newElement.object = true;
      }

      if (hasProperty(property, "$ref")) {
        let entityName = property.$ref.slice(14);
        let entity = this.schema?.definitions[entityName];
        newElement.type = "multiselect";
        if (hasProperty(entity, "model")) {
          newElement.items = {
            entity: entity?.model,
            valueName: "id",
            titleName: property.title_field_name
              ? property.title_field_name
              : "name",
          };

          newElement.object = true;
        }
        if (hasProperty(entity, "enum")) {
          newElement.items = entity.enum;
        }
      }
      if (hasProperty(property, "format")) {
        switch (property.format) {
          case "date-time":
            newElement.type = "datetime";
            break;
          default:
            break;
        }
        // console.log(property.format);
      }
      if (this.schema?.required && this.schema?.required.includes(item)) {
        newElement.rules = ["required"];
      }
      if (
        this.schema?.readonly_fields &&
        (this.schema?.readonly_fields.includes(item) ||
          this.cardType === "show")
      ) {
        newElement.readonly = true;
        newElement.disabled = true;
      }

      if (hasProperty(newElement, "type")) {
        return newElement;
      } else return null;
    },
    generateNewFileElement(item, property) {
      let newElement = {
        type: "file",
        id: item,
        name: item,
        label: property.title,
        fileType: property?.type,
        linkType: property?.link_type,
        columns: {
          container: 6,
        },
      };
      return newElement;
    },
    isFileField(field) {
      return this.schema?.file_fields.includes(field) ? true : false;
    },
    generateSchema(entityFields) {
      if (entityFields && isObject(entityFields.properties)) {
        let schema = [];
        for (let key in entityFields.properties) {
          if (!this.isFileField(key)) {
            let el = this.generateNewSchemaElement(
              key,
              entityFields.properties[key]
            );
            if (el) {
              schema.push(el);
            }
          } else {
            schema.push(
              this.generateNewFileElement(key, entityFields.properties[key])
            );
          }
        }
        // console.log(schema);
        return schema;
      }
    },

    removeNotSaved() {
      if (this.filesNotSaved.length > 0) {
        this.filesNotSaved.map((ff) => {
          EntityApi.sendCustomRequest(
            "/delete-file?file_name=" + ff,
            "post",
            null
          ).then(() => {
            const idx = this.filesNotSaved.findIndex((fileI) => fileI == ff);
            if (idx > -1) {
              this.filesNotSaved.splice(idx, 1);
            }
          });
        });
      }
    },
    updateInstanceData(fieldName, newValue) {
      //console.log("updateInstanceData", fieldName, typeof newValue, newValue);

      //remove not saved files
      const indx = this.formShema.findIndex(
        (field) => field.type == "file" && field.name == fieldName
      );
      if (newValue && indx > -1) {
        this.filesNotSaved.push(newValue);
      }

      this.formData[fieldName] = newValue;
    },
    async saveInstance() {
      this.validateForm();

      this.$nextTick(() => {
        if (this.formError) {
          console.log("form has errors");
        } else {
          let payl = { ...this.formData };
          let keys = Object.keys(this.schema?.properties || {});

          keys.forEach((key) => {
            if (
              this.schema?.properties[key]?.type === "multiselect" ||
              this.schema?.properties[key]?.type === "weekdays"
            ) {
              if (Array.isArray(payl[key]) && payl[key].length > 0) {
                payl[key] = payl[key].map((el) => el.id);
              } else {
                payl[key] = [];
              }
            }
          });
          switch (this.cardType) {
            case "create":
              this.spinnerShow = true;
              EntityApi.createEntityItem(this.entity, payl).then((res) => {
                if (res) {
                  this.filesNotSaved = [];
                  this.$emit("inctanseCreate", res);
                  this.$notify(
                    {
                      group: "alert",
                      type: "info",
                      title: this.$t("lables.success"),
                      text: this.$t("lables.saved"),
                    },
                    3000
                  );
                } else {
                  this.$notify(
                    {
                      group: "alert",
                      type: "error",
                      title: this.$t("lables.error"),
                      text: this.$t("lables.saved_not"),
                    },
                    3000
                  );
                }
              });
              this.spinnerShow = false;

              break;
            default:
              this.spinnerShow = true;

              EntityApi.updateEntityItem(this.entity, payl).then((res) => {
                if (res) {
                  this.filesNotSaved = [];

                  this.$notify(
                    {
                      group: "alert",
                      type: "info",
                      title: this.$t("lables.success"),
                      text: this.$t("lables.saved"),
                    },
                    3000
                  );
                  this.$emit("inctanseDataUpdate", this.formData);
                } else {
                  this.$notify(
                    {
                      group: "alert",
                      type: "error",
                      title: this.$t("lables.error"),
                      text: this.$t("lables.saved_not"),
                    },
                    3000
                  );
                }
              });
              this.spinnerShow = false;
              break;
          }
        }
      });
    },
    getUpdated(payload) {
      if (Object.keys(payload).length) {
        this.formData = { ...this.formData, ...payload };
        this.$emit("dataUpdate", this.formData);
      }
    },
    closeModal() {
      this.$emit("closeModal");
    },
    onTabChange(tab) {
      if (this.item?.id) {
        this.activeTab = null;
        this.activeTab = tab;
      } else {
        this.validateForm();
      }
    },
    validateForm() {
      this.formError = null;
      this.$refs.dinamicForm.validateForm();
    },
    onValidationError(errors) {
      this.formError = errors;
    },
    setScroll() {
      const windowHeight = window.innerHeight;
      const contentModalHeight = windowHeight * this.heightMult;

      let dinamicFormHeight;
      /*if (this.dinamicFormHeight === 0) {
        const dinamicForm = this.$refs.dinamicFormContainer;
        dinamicFormHeight = dinamicForm.clientHeight;
      } else {
        dinamicFormHeight = this.dinamicFormHeight;
      }*/
      dinamicFormHeight = this.$refs.dinamicFormContainer.clientHeight;

      if (dinamicFormHeight > contentModalHeight) {
        const tabsContent = this.$refs.tabsContent;
        tabsContent.style.overflow = "auto";
      }
    },
    onSetFormHeight(params) {
      this.dinamicFormHeight = params;
      this.setScroll();
    },
    ExportEntity() {
      this.show({
        message: "You want to export this entity to conveniq?",
        okButton: this.$t("otp.yes"),
        cancelButton: this.$t("otp.no"),
      }).then((data) => {
        if (data) {
          this.spinnerShow = true;
          EntityApi.UploadEntityCommand(this.entity, this.item.id).then(
            (res) => {
              this.spinnerShow = false;
              if (res) {
                this.$notify(
                  {
                    group: "alert",
                    type: "info",
                    title: this.$t("lables.success"),
                    text: "Export sended, no feedback for conveniq. Vers 0.2",
                  },
                  8000
                );

                this.closeModal();
              } else {
                this.$notify(
                  {
                    group: "alert",
                    type: "error",
                    title: this.$t("lables.error"),
                    text: "Cant start export to conveniq",
                  },
                  3000
                );
              }
            }
          );
        }
      });
    },
    show(opts = {}) {
      this.dialogueMessage = opts?.message ? opts.message : "Are you sure?";
      this.okButton = opts?.okButton ? opts.okButton : "Yes";
      this.cancelButton = opts?.cancelButton ? opts.cancelButton : "No";

      this.showDialogue = true;

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    _confirm() {
      this.showDialogue = false;
      this.resolvePromise(true);
    },
    _cancel() {
      this.showDialogue = false;
      this.resolvePromise(false);
    },
  },
  created() {
    this.formShema = this.generateSchema(this.schema);

    let data_item = this.item;
    let keys = Object.keys(this.schema?.properties || {});

    keys.forEach((key) => {
      if (this.schema?.properties[key]?.type === "weekdays") {
        if (Array.isArray(data_item[key]) && data_item[key].length > 0) {
          const ids = data_item[key].map((item) =>
            isObject(item) ? item.id : item
          );
          data_item[key] = this.weekdays.filter((wd) => ids.includes(wd.id));
        }
      }
    });
    this.formData = data_item;

    if (this.defaultValues) {
      this.formData = { ...this.formData, ...this.defaultValues };
    }
    // if( this.schema.table_fields && Array.isArray(this.schema.table_fields) && this.schema.table_fields.length > 0) {
    //   this.activeTab = this.schema.properties[this.schema.table_fields[0]].title;
    // }
  },
  mounted() {
    console.log("InstanceCard mounted");
    this.setScroll();
  },
  beforeUnmount() {
    this.removeNotSaved();
  },
};
</script>
<style scoped>
.top-panel {
  padding-top: 6px;
  padding-left: 20px;
}

.item-id {
  font-size: 12px;
  color: rgb(175, 174, 174);
}

.show-scroll {
  overflow: auto;
}

.hide-scroll {
  overflow: hidden;
}
</style>
